const acknowledgeData = [
  {
    otherReason: 'Suffering from a terminal medical condition',
    title: 'To start a pension under these circumstances, the member must have received some medical certificates about their condition:',
    items: [
      'they must confirm that the member is suffering from an illness or injury likely to cause death within 2 years from the date of the certificate',
      'at least one of the certificates must be provided from a specialist who practices in an area relevant to the condition',
      'the pension must start before the 2 year period ends',
    ],
    post: '',
  },
  {
    otherReason: 'Permanently incapacitated',
    title: 'Permanent incapacity has a specific meaning in superannuation law. It means that:',
    items: [
      'the trustee believes the member is suffering from physical or mental ill-health',
      'it is unlikely the member will ever be able to take on paid work for which they are qualified by training, education or experience',
    ],
    post: 'There is no specific requirement for the trustee to hold medical certificates that confirm this - to start a pension the trustee simply has to be satisfied of the position. However, if the pensioner is under 60, there are some special tax concessions that only apply if medical certificates are held.',
  },
  {
    otherReason: 'The pension will be a transition to retirement pension',
    title: 'A transition to retirement pension can commence any time after a member reaches their preservation age.  The pension will be subject to some special restrictions (such as upper limits on payment amounts) until the member meets another condition (such as retiring or turning 65).',
    items: [],
    post: '',
  },
  {
    otherReason: 'Permanently retired',
    title: 'A member is permanently retired for this purpose if, at the time the pension starts, they have:',
    items: [
      'reached their preservation age, and',
      'ceased a paid work arrangement (including self employment) at some point in the past (not necessarily recently); and',
      'never intend to work 10 or more hours per week in a paid work arrangement again in the future.',
    ],
    post: '',
  },
  {
    otherReason: 'Ended a paid work arrangement after turning 60',
    title: 'This condition will be met if the member ended a paid work arrangement (including self employment) after their 60th birthday and the pension starts on or after the date this occurred. Note that if the member’s balance has grown since the paid work arrangement ended (eg new contributions or new earnings), this growth will be preserved until another condition of release is met. The pension should therefore:',
    items: [
      'commence with only the balance at the time the paid work arrangement ended (in which case the pension will be a normal account-based pension), or',
      'be classified as a transition to retirement pension if the pension is to commence with a balance that includes any subsequent growth. In this case, change your selection to “the pension will be a transition to retirement pension” above.',
    ],
    post: '',
  },
  {
    otherReason: 'other',
    title: 'Make sure the wording you provide demonstrates that a valid condition of release has been met, allowing the pension to commence as our tool will rely on your wording here.',
    items: [],
    post: '',
  },
];

const getAcknowledgeData = reason => acknowledgeData.find(item => item.otherReason === reason);

export default getAcknowledgeData;
